import { Navigate, Route, Routes } from 'react-router-dom';
import DiscoverPage from '@/features/discover/pages/DiscoverPage';
import ChatPage from '@/features/chat/pages/ChatPage';
import ProfilePage from '@/features/profile/pages/ProfilePage';
import SharePage from '@/features/share/pages/SharePage';
import HealthPage from '@/features/settings/pages/HealthPage';
import { NotFoundPage } from './NotFoundPage';
import { RefIdHandler } from './RefIdHandler';

export const AppRouter = () => (
  <RefIdHandler>
    <Routes>
      <Route path="/" element={<DiscoverPage />} />
      <Route path="/discover" element={<Navigate to="/" replace />} />
      <Route path="/chat" element={<ChatPage />} />
      <Route path="/chat/:userId" element={<ChatPage />} />
      <Route path="/share" element={<SharePage />} />
      <Route path="/profile" element={<ProfilePage />} />
      <Route path="/settings" element={<Navigate to="/profile" replace />} />
      <Route path="/health" element={<HealthPage />} />
      <Route path="*" element={<NotFoundPage />} />
    </Routes>
  </RefIdHandler>
);
